<template>
  <div class="page-add">
    <div class="add-title">新增临时用户</div>
    <base-form formType="add"></base-form>
  </div>
</template>

<script>
import BaseForm from "./baseForm.vue";

export default {
  components: { BaseForm },
  created() {

  },
  methods:{
  },

};
</script>

<style lang="scss" scoped>

</style>
